import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { configData } from "./config";
import { HelmetProvider } from "react-helmet-async";

//const currentDomain = window.location.hostname;
const currentDomain = window.location.host.replace(/^https?:\/\//, '');
const root = ReactDOM.createRoot(document.getElementById('root'));
const drupal_domain_url = configData.DRUPAL_DOMAIN_URL;
root.render(
  <React.StrictMode>
    <HelmetProvider>
    <App />
    </HelmetProvider>
  </React.StrictMode>
);
const url = new URL('', window.location.href);
if (currentDomain.includes(configData.RSMWW_SCOUT_DOMAIN) || currentDomain.includes(configData.RSMWW_SCOUT_DOMAIN1) || currentDomain.includes(configData.RSMWW_SCOUT_DOMAIN2)) {
} 
else if (currentDomain.includes(configData.RSMWW_AGENCY_DOMAIN) || currentDomain.includes(configData.RSMWW_AGENCY_DOMAIN1)) {
}
else {
if(url.pathname === '/') {
  window.location.href = drupal_domain_url;
}
}

if (!crypto.randomUUID) {
    crypto.randomUUID = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
